// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"9ba37967","972":"20bd1e71"}[chunkId] + ".chunk.css";
};